/*
 * Copyright (c) 2022 biocrates life sciences ag, All rights reserved.
 */

import {combineEpics} from "redux-observable"

import settingsEpic from "../settings/epics/settings.epic"

export default combineEpics(settingsEpic)
